export default __webpack_public_path__ + "static/media/xiaoshouguanli_w.a25afa43.png";